import { ProductSearchModal } from "//orimine.co.jp/cdn/shop/t/9/assets/product-search-modal.js?v=12&v=111491872360814744241780884207"
import { ProductSearch } from "//orimine.co.jp/cdn/shop/t/9/assets/product-search.js?v=10&v=174879115663272390641791995743";

// 絞り込み条件の控え (2026-09-25)。商品ページ上部の「絞り込み条件」バーが読む。
// 2026-10-09 からは同じ処理で一覧の上 (絞り込みボタンの下) にも条件のチップを出す (案 A)。
// 読み込み番号は filter-context.js の中身を変えたら上げる (v=1 = 9/25 の版。旧検証テーマの CDN に乗っている。
// v=3 = 2026-10-28 の版 = 一覧で押した商品を控える、台帳 S-11)。
//
// 🔴 静的 import にしない。静的 import だと filter-context.js の読み込みに
//    失敗した時点でこのモジュール全体 = 一覧の検索が動かなくなる。
//    控えは装飾なので、失敗しても検索本体を止めない (バッジ / CTA 件数と同じ方針)。
//    読み込みは今すぐ始めるので、初回検索が終わる頃には手元にある。
const filterContextModule = import("//orimine.co.jp/cdn/shop/t/9/assets/filter-context.js?v=3&v=158382718859147162121793166068").catch((error) => {
  console.warn('[filter-context] 読み込みに失敗しました:', error);
  return null;
});

$(document).ready(function () {

  // 検索を実行し、終わったら「今かかっている条件」を控え、一覧の上にもチップで出す。
  //
  // 🔴 控えるのは検索が終わった後 = 画面に出ている結果と同じ条件。
  //    リセットボタン (送信しない) では控え直さない。リセットしただけで
  //    商品を開いた場合、画面の結果はリセット前の条件のままなので、
  //    バーもそれに合わせる。一覧の上のチップも同じ (画面の結果と食い違わせない)。
  // 🔴 付属品のぴったり検索 (my-product-detail-accessory-search-box.js) は
  //    この経路を通らない = 控えない。あちらは一覧ではないため。
  const submitAndRemember = (form, scrollToSection) =>
    ProductSearch.submitSearchForm(form, scrollToSection).then(() =>
      filterContextModule.then((module) => {
        if (module) module.FilterContext.save(form);
      })
    );

  // ------------------ formの初期化関数 ---------------------

  const setUpSearchForm = async ()=> {
    // スライダーを初期化。fromInputの変更に対してリッスンする
    ProductSearch.setUpSliders();
    ProductSearch.resetSliders();

    // my-search-boxのフォーム送信をリッスンする
    const form = document.getElementById('my-search-box');
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      // 絞り込みドロワーの CTA から送信された場合はここで閉じる。
      // CTA に data-drawer-close は付けられない (my-drawer.js の close ハンドラが
      // preventDefault するため submit 自体が発火しなくなる) ので、
      // 「適用して閉じる」はフォーム側の責務として持つ。
      if (window.myDrawer) window.myDrawer.close('filter-drawer');
      submitAndRemember(e.target);
    });

    // my-search-boxのリセットボタンをリッスンする
    const resetButton = document.getElementById('my-search-box-reset-button');
    resetButton.addEventListener('click', async (e) => {
      e.preventDefault();
      ProductSearch.resetForm(form);
      ProductSearch.setURLParametersFromForm($(form));
      ProductSearch.setFilterBadge(form);
      // 🔴 form.reset() は input / change を発火しないので、下の
      //    $(form).on('input change') 経由では CTA の件数が更新されない。
      //    ここで明示的に呼ぶ。
      ProductSearch.scheduleDrawerCount(form);
    });

    // 絞り込みバッジ (適用中の条件数) をフォームの変更に追従させる。
    // jQuery で束ねているのは、スライダーが $(el).trigger('input') で値を更新するため
    // (jQuery の trigger はネイティブの addEventListener を呼ばない)。
    //
    // 🔴 try/catch は必須。この handler は setFormFromURLParameters の
    //    field.trigger('input') からも呼ばれるため、ここで例外を投げると
    //    初期化チェーンごと巻き込んで商品が 1 件も描画されなくなる。
    //    バッジは装飾なので、失敗しても検索本体を止めてはいけない。
    //
    // CTA「N件を表示」のリアルタイム件数もここに相乗りさせる (2026-09-03)。
    // トリガーは同じ「ドロワー内のフォームが変わったとき」で、
    // 小カテゴリ / タグのチェック・価格スライダー・キーワード入力を全部拾う。
    // 実際の送信はデバウンス (300ms) 後 = ドラッグ中は連打しない。
    $(form).on('input change', () => {
      try {
        ProductSearch.setFilterBadge(form);
      } catch (e) {
        console.error('[filter-badge] 更新に失敗しました:', e);
      }
      // 🔴 バッジとは try を分ける。片方の失敗でもう片方を落とさない。
      //    どちらも装飾なので、失敗しても初期化チェーン (= 商品の描画) を
      //    止めてはいけない。
      try {
        ProductSearch.scheduleDrawerCount(form);
      } catch (e) {
        console.error('[filter-cta] 件数の予約に失敗しました:', e);
      }
    });

    // ドロワーを開いた時点でも 1 回取る。フォームの状態と CTA の数字を
    // 開いた瞬間に一致させるため (前回検索後に URL 復元などで値が変わって
    // いる可能性があり、開いた直後の数字が古いままになるのを防ぐ)。
    // my-drawer.js が 'my-drawer:open' を bubbles: true で投げている。
    document.addEventListener('my-drawer:open', (event) => {
      const drawer = event.target;
      if (!drawer || drawer.getAttribute('data-drawer') !== 'filter-drawer') return;
      try {
        ProductSearch.scheduleDrawerCount(form);
      } catch (e) {
        console.error('[filter-cta] 件数の予約に失敗しました:', e);
      }
    });

    // my-result-sort-selectの変更をリッスンする
    const sortSelect = document.getElementById('my-result-sort-select');
    sortSelect.addEventListener('change', async (e) => {
      submitAndRemember(form, false);
    });

    // load moreボタンをリッスンする
    const loadMoreButton = document.getElementById('loadMoreButton');
    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', async (e) => {
        e.preventDefault();
        e.target.disabled = true;
        await ProductSearch.loadMoreProducts(form).then(() => {
          e.target.disabled = false;
        });
      });
    }
  }

  // ------------------ 画面読み込み時の実行処理 ---------------------

  setUpSearchForm().then(() => {
    // console.log('画面読み込み完了');
    // console.log('test!');
    // ページ読み込み時にURLパラメータをフォームにセット
    const form = document.getElementById('my-search-box');
    ProductSearch.setFormFromURLParameters(form).then(() => {
      // URL に絞り込みが乗っている状態で開かれることがあるため、初期表示でも数える。
      // 🔴 バッジの失敗で submitSearchForm に到達できなくなると商品が 0 件のままになる。
      //    装飾のために本体を止めない。
      try {
        ProductSearch.setFilterBadge(form);
      } catch (e) {
        console.error('[filter-badge] 初期化に失敗しました:', e);
      }
      // 初回表示でも控える (URL に条件が載った一覧を開いた / 戻ってきた場合)。
      // 条件が 1 つも無ければ控えは作られない = そこから開いた商品にバーは出ない
      submitAndRemember(form, false);
    }).catch((error) => {
      console.error('Error(setFormFromURLParameters):', error);
    });
  }).catch((error) => {
    console.error('Error:', error);
  });
  ProductSearchModal.setUpSearchModal().then(() => {
    // console.log('モーダル初期化完了');
    ProductSearchModal.setModalSummary();
  }).catch((error) => {
    console.error('Error:', error);
  });

});
